import { Controller } from "@hotwired/stimulus";
import { formSubmitWithWaitForJobCompletion } from "../../scripts/jobCompletion";
import { reloadWithTurbo } from "../../scripts/turboHelper";

export default class AddPoiToBaseDestinationController extends Controller {
    static targets = [
        "form",
        "submit"
    ];

    static values = {
        getJobUrl: String
    };

    readonly formTarget!: HTMLElement;
    readonly submitTarget!: HTMLElement;

    readonly getJobUrlValue!: string;
    
    connect() {
        formSubmitWithWaitForJobCompletion(
            $(this.formTarget),
            $(this.submitTarget),
            this.getJobUrlValue,
            () => {
                reloadWithTurbo();
            },
            "Really add Place to the Base Destination?"
        );
    }
}
